import script from "./MainRegisterComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MainRegisterComponent.vue?vue&type=script&setup=true&lang=js"

import "./MainRegisterComponent.vue?vue&type=style&index=0&id=39e17165&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39e17165"]])

export default __exports__